import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { applyTheme, readTheme } from "./theme";
import "./styles.css";

// D-066: the console starts light like the vendor dashboard; the account menu changes it.
applyTheme(readTheme());

/** DEV ONLY: the MSW mock API, removed from production builds (scripts/assert-no-mocks.mjs checks). */
async function enableMocks(): Promise<void> {
  if (import.meta.env.DEV && import.meta.env.VITE_ADY_MOCKS !== "off") {
    const { startMocks } = await import("./mocks");
    await startMocks();
    (globalThis as { __ADY_MOCKS__?: boolean }).__ADY_MOCKS__ = true;
  }
}

void enableMocks().then(() => {
  const root = document.getElementById("root");
  if (!root) throw new Error("#root missing");
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
});
